import script from "./NodataView.vue?vue&type=script&setup=true&lang=js"
export * from "./NodataView.vue?vue&type=script&setup=true&lang=js"

import "./NodataView.vue?vue&type=style&index=0&id=4e57edc8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e57edc8"]])

export default __exports__